import { SubmitEvent, useState } from 'react';
import { PopoverMenu } from '@/components/PopoverMenu/PopoverMenu';
import { Input } from '@/components/form/fields/Input/Input';
import { ButtonNew } from '@/components-new/ButtonNew/ButtonNew';
import { JumpForm, PaginatorDots } from './styles';

type PaginatorJumpType = {
  totalPagesCount: number;
  onJump: (pageIndex: number) => void;
};

export const PaginatorJump = ({ totalPagesCount, onJump }: PaginatorJumpType) => {
  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState('');

  const pageNumber = Number(value);
  const isValid = Number.isInteger(pageNumber) && pageNumber >= 1 && pageNumber <= totalPagesCount;

  const close = () => {
    setIsOpen(false);
    setValue('');
  };

  const submit = (event: SubmitEvent) => {
    event.preventDefault();

    if (!isValid) return;

    onJump(pageNumber - 1);
    close();
  };

  return (
    <PopoverMenu
      isOpen={isOpen}
      onToggleOpen={(open) => (open ? setIsOpen(true) : close())}
      placement='top'
      returnFocus={false}
      anchorSlot={
        <PaginatorDots as='button' type='button' aria-label='Go to page'>
          ...
        </PaginatorDots>
      }
    >
      <JumpForm onSubmit={submit}>
        <Input
          autoFocus
          hasErrorComponent={false}
          variant='small'
          name='page'
          type='number'
          min={1}
          max={totalPagesCount}
          value={value}
          placeholder={`1 - ${totalPagesCount}`}
          onChange={(event) => setValue(event.target.value)}
        />
        <ButtonNew type='submit' size='medium' disabled={!isValid}>
          Go
        </ButtonNew>
      </JumpForm>
    </PopoverMenu>
  );
};
